import {forwardRef} from 'react'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Button} from '@/components/ui/button/Button'
import {Expand01Icon} from '@/components/ui/icon/Icon'
import {Grid, GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {TextArea, TextAreaProps} from '@/components/commons/textarea/TextArea'
import {useMedicalReportTextAreaStore} from '../../stores/medicalReportTextAreaStore'
import {useMedicalPreviousReportContext} from '../../hooks/useMedicalPreviousReportContext'
import {MedicalReportSplitViewButton} from '../medical-report-split-view-button/MedicalReportSplitViewButton'
import {FormInputTxtCounter} from '@/components/ui/form-atoms/FormAtoms'
import {StyledReadOnlyView} from './style'

interface ExpandableTextAreaFieldProps extends TextAreaProps {
    canSplit?: boolean
    currentField?: string
}

export const MedicalReportTextAreaField = forwardRef<HTMLTextAreaElement, ExpandableTextAreaFieldProps>(
    ({errorMessage, canSplit, currentField, ...props}, ref) => {
        const count = props.value?.toString().length || 0
        const {openModal, selectedField, isSplitView} = useMedicalReportTextAreaStore()
        const {previousReport} = useMedicalPreviousReportContext()

        return (
            <Flexbox direction="column" gap={1} fullWidth>
                <Flexbox align="center" justify={previousReport ? 'space-between' : 'flex-end'} fullWidth>
                    <MedicalReportSplitViewButton currentField={currentField ?? ''} />
                    {!selectedField && currentField && (
                        <Button
                            type="button"
                            variant="secondary"
                            size="xs"
                            shape="square"
                            onClick={() => openModal(currentField)}
                        >
                            <Expand01Icon />
                        </Button>
                    )}
                </Flexbox>

                <Grid fullWidth columnGap={2} columns={isSplitView && previousReport && canSplit ? 2 : 1}>
                    {isSplitView && previousReport && canSplit && (
                        <GridItem fullWidth>
                            <StyledReadOnlyView>{previousReport}</StyledReadOnlyView>
                        </GridItem>
                    )}
                    <GridItem fullWidth>
                        <TextArea {...props} ref={ref} />
                    </GridItem>
                </Grid>

                <FormInputTxtCounter limit={props.maxLength} count={count} errorMessage={errorMessage} />
            </Flexbox>
        )
    }
)
